import { render, staticRenderFns } from "./textCopy.vue?vue&type=template&id=5d939f15"
import script from "./textCopy.vue?vue&type=script&lang=js"
export * from "./textCopy.vue?vue&type=script&lang=js"
import style0 from "./textCopy.vue?vue&type=style&index=0&id=5d939f15&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d939f15')) {
      api.createRecord('5d939f15', component.options)
    } else {
      api.reload('5d939f15', component.options)
    }
    module.hot.accept("./textCopy.vue?vue&type=template&id=5d939f15", function () {
      api.rerender('5d939f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/textCopy.vue"
export default component.exports